export default "__VITE_ASSET__uBvH4M87__"